var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuButtonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FCDB94EA-C1E3-4882-827C-45E2F057022C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main17",
    transform: "translate(-713, -707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2",
    transform: "translate(252, 707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menuButton",
    transform: "translate(461, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "lil-icons-/-go",
    transform: "translate(6, 6)",
    stroke: "#181C32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "go",
    transform: "translate(4, 4) scale(-1, 1) rotate(90) translate(-4, -4)",
    points: "0 2 4 6 8 2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButtonBlack);
export default __webpack_public_path__ + "static/media/menu-button-black.fe8e970b14bb1e137371583264b1b0f6.svg";
export { ForwardRef as ReactComponent };